import { Brand, BrandProperties, Environments } from 'types';
import {
  AnacapriIcon,
  ArezzoIcon,
  BirmanIcon,
  FieverIcon,
  OwmeIcon,
  SchutzIcon,
  VansIcon,
  VicenzaIcon,
} from 'static/icons';

export const localEnv = Environments.Local;

export const ENV: Environments =
  (process.env.REACT_APP_ENVIRONMENT as Environments) ?? localEnv;

// TODO remove from code
export const CAPTCHA_KEY = '6LesQ78dAAAAAIqAPYN8yapjnUewRjFGTEf7Kf7j';

export const BRAND_PROPERTIES: Record<Brand, BrandProperties> = {
  anacapri: {
    code: 'anacapri',
    displayName: 'Anacapri',
    shortName: 'ANA',
    icon: <AnacapriIcon />,
    url: {
      local: 'https://integ02.anacapri.com.br',
      dev: 'https://integ02.anacapri.com.br',
      preprod: 'https://preprod.anacapri.com.br',
      hotfix: 'https://hotfix.anacapri.com.br',
      prod: 'https://www.anacapri.com.br',
    },
  },
  arezzo: {
    code: 'arezzo',
    displayName: 'Arezzo',
    shortName: 'ARZ',
    icon: <ArezzoIcon />,
    url: {
      local: 'https://integ02.arezzo.com.br',
      dev: 'https://integ02.arezzo.com.br',
      preprod: 'https://preprod.arezzo.com.br',
      hotfix: 'https://hotfix.arezzo.com.br',
      prod: 'https://www.arezzo.com.br',
    },
  },
  birman: {
    code: 'birman',
    displayName: 'Alexandre Birman',
    shortName: 'BIR',
    icon: <BirmanIcon />,
    url: {
      local: 'https://integ02.alexandrebirman.com.br',
      dev: 'https://integ02.alexandrebirman.com.br',
      preprod: 'https://preprod.alexandrebirman.com.br',
      hotfix: 'https://hotfix.alexandrebirman.com.br',
      prod: 'https://www.alexandrebirman.com.br',
    },
  },
  fiever: {
    code: 'fiever',
    displayName: 'Fiever',
    shortName: 'FIE',
    icon: <FieverIcon />,
    url: {
      local: 'https://integ02.fiever.com.br',
      dev: 'https://integ02.fiever.com.br',
      preprod: 'https://preprod.fiever.com.br',
      hotfix: 'https://hotfix.fiever.com.br',
      prod: 'https://www.fiever.com.br',
    },
  },
  schutz: {
    code: 'schutz',
    displayName: 'Schutz',
    shortName: 'SCH',
    icon: <SchutzIcon />,
    url: {
      local: 'https://integ02.schutz.com.br',
      dev: 'https://integ02.schutz.com.br',
      preprod: 'https://hml.schutz.com.br',
      hotfix: 'https://hotfix.schutz.com.br',
      prod: 'https://app.schutz.com.br',
    },
  },
  vans: {
    code: 'vans',
    displayName: 'Vans',
    shortName: 'VNS',
    icon: <VansIcon />,
    url: {
      local: 'https://integ02.vans.com.br',
      dev: 'https://integ02.vans.com.br',
      preprod: 'https://hml.vans.com.br',
      hotfix: 'https://hotfix.vans.com.br',
      prod: 'https://www.vans.com.br',
    },
  },
  owme: {
    code: 'owme',
    displayName: 'Alme',
    shortName: 'ALM',
    icon: <OwmeIcon />,
    url: {
      local: 'https://integ02.somosalme.com.br',
      dev: 'https://integ02.somosalme.com.br',
      preprod: 'https://preprod.somosalme.com.br',
      hotfix: 'https://hotfix.somosalme.com.br',
      prod: 'https://www.somosalme.com.br',
    },
  },
  vicenza: {
    code: 'vicenza',
    displayName: 'Vicenza',
    shortName: 'VCZ',
    icon: <VicenzaIcon />,
    url: {
      local: 'https://integ02.vicenza.com.br',
      dev: 'https://integ02.vicenza.com.br',
      preprod: 'https://preprod.vicenza.com.br',
      hotfix: 'https://hotfix.vicenza.com.br',
      prod: 'https://www.vicenza.com.br',
    },
  },
};
